export const riskDisclosure = 'risk-disclosure';
export const returnPolicy = 'return-policy';
export const amlPolicy = 'aml-policy';
export const privacyPolicy = 'privacy-policy';
export const aboutUs = 'about-us';
